<template>
  <div class="space-detail-container">
    <el-dialog
      :close-on-click-modal="false"
      @closed="$emit('close')"
      :visible.sync="isShow"
      custom-class="custom-dialog--small"
      :show-close="false"
    >
      <dialog-close-icon
        mode="blue"
        class="dialog-close-icon"
        @close="isShow = false"
      ></dialog-close-icon>
      <div class="dialog-wrapper">
        <div class="space-area">
          <div class="space-bg">
            <img src="@/images/currentCabinHall/map_bg.png" />
          </div>
          <div class="space-wrapper">
            <div class="row-1">
              <div class="shipping">
                <!-- <img
                  class="icon"
                  src="https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83epkes74IYPibTN3C42RLw7JIr04ULM0PQia0rP5CQBjjcia6Hq72xyart7GN5WKcQ6Kico9msPVdWU9Bg/132"
                />
                <div class="text">长荣船务,</div> -->
                <img
                  class="date-icon"
                  src="@/images/currentCabinHall/calendar.png"
                />
              </div>
              <!-- <div class="date">开航日 2020-02-05</div> -->
              <div class="date">可装柜日期 {{detailData.etdStr}}</div>
            </div>
            <div class="row-2">
              <div class="port start">
                <div class="en">{{detailData.portstartname}}</div>
                <div class="cn">{{detailData.portstartnameCn}}</div>
              </div>
              <div class="arrow">
                <img src="@/images/currentCabinHall/arrow.png" />
              </div>
              <div class="port end">
                <div class="en">{{detailData.portendname}}</div>
                <div class="cn">{{detailData.portendnameCn}}</div>
              </div>
            </div>
            <div class="row-3">
              <div class="text-1">
                出运箱型：<span class="orange">{{detailData.containerTypeStr}}</span>
              </div>
              <div class="text-2 mt16">货物类型：{{detailData.goodsTypeStr}}</div>
              <div class="text-2">
                <div class="label">出运要求：</div>
                <div class="value">
                  {{detailData.description}}
                </div>
              </div>
              <div class="text-3">发布时间：{{detailData.updateTimeStr}}</div>
            </div>
          </div>
        </div>
        <div class="user-area">
          <div class="row-1">联系发布人</div>
          <div class="row-2">
            <div class="left">
              <img
                class="photo-img"
                :src="detailData.salesHead?detailData.salesHead:require('@/images/common/noAvatar.png')"
              />
            </div>
            <div class="right">
              <div class="name">{{detailData.salesName}}</div>
              <div class="company">{{detailData.companyName}}</div>
            </div>
          </div>
          <div class="split"></div>
          <div class="row-3">
            <span class="label">电话</span
            ><span class="value">{{detailData.salesTel}}</span>
          </div>
          <div class="row-3">
            <span class="label">QQ</span>
            <span class="value hand" @click="addQQ(detailData.qq)">{{detailData.qq}}</span>
          </div>
          <div class="row-3">
            <span class="label">邮箱</span
            ><span class="value">{{detailData.email}}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { wzqueryMpSpace } from "@/api/currentCabinHall/currentCabinHall";
export default {
  props:{
    id: {
      type: Number,
    }
  },
  data() {
    return {
      isShow: true,
      detailData:{},
    };
  },
  created() {
    this.wzspacescreenlist();
  },
  mounted() {},
  methods: {
    // 筛选列表
    async wzspacescreenlist() {
      // ==========接口调用==========
      let res;
      let params = {
        id:this.id,
      };
      try {
        res = await wzqueryMpSpace(params);
        console.log("wzqueryMpSpace",res)
        this.detailData = res;
      } catch (e) {
        console.error(e);
      }
    },
    // qq聊天
    addQQ(qq){
        if(qq){
          window.location.href="tencent://AddContact/?fromId=45&fromSubId=1&subcmd=all&uin="+qq+"&website=www.oicqzone.com"
        }
    },
  },
};
</script>

<style scoped lang="scss">
.space-detail-container {
  .dialog-close-icon {
    z-index: 1;
  }
  .dialog-wrapper {
    .space-area {
      width: 584px;
      background: linear-gradient(-16deg, #0081ff 0%, #2192ff 100%);
      border-radius: 8px 8px 0px 0px;
      width: 100%;
      min-height: 290px;
      position: relative;
      z-index: 0;
      padding-bottom: 30px;
      .space-bg {
        position: absolute;
        width: 100%;
        top: 0px;
        left: 0px;
        padding-top: 13px;
        img {
          width: 493px;
          height: auto;
          margin: auto;
        }
      }
      .space-wrapper {
        padding: 40px 40px 0;
        position: relative;
        z-index: 1;
        .row-1 {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
          margin-bottom: 20px;

          .shipping {
            display: flex;
            align-items: center;
            .icon {
              margin-right: 10px;
              display: block;
              width: 34px;
              height: 34px;
              border-radius: 50%;
            }
            .text {
            }
            .date-icon {
                margin-right: 8px;
                width: 16px;
            }
          }
          .date {
          }
        }
        .row-2 {
          display: flex;
          align-items: center;
          width: 100%;
          overflow: hidden;
          .port {
            overflow: hidden;
            width: calc((100% - 60px) / 2);
            flex: 0 0 auto;
            .en {
              width: 100%;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 20px;
              font-weight: bold;
              color: #ffffff;
              margin-bottom: 6px;
            }
            .cn {
              width: 100%;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;

              font-size: 12px;
              font-weight: 500;
              color: rgba(255, 255, 255, 0.7);
            }
            &.start {
              text-align: left;
            }
            &.end {
              text-align: right;
            }
          }
          .arrow {
            width: 40px;
            flex: 0 0 auto;
            margin: 0 10px;
            img {
              display: block;
              width: 100%;
              height: auto;
            }
          }
        }
        .row-3 {
          margin-top: 20px;
          width: 100%;
          padding: 18px 10px 20px;
          background: rgba(235, 238, 243, 0.2);
          border-radius: 10px;
          .text-1 {
            font-size: 14px;
            font-weight: bold;
            color: #ffffff;
            .orange {
              color: #ffa95c;
            }
          }
          .text-2 {
            font-size: 12px;
            font-weight: 500;
            color: #ffffff;
            line-height: 22px;
            display: flex;
            align-items: flex-start;
            .label {
              flex: 0 0 auto;
            }
            .value {
            }
          }
          .text-3 {
            margin-top: 4px;
            font-size: 12px;
            font-weight: 500;
            color: #ffffff;
          }
        }
      }
    }
    .user-area {
      width: 100%;
      background: #ffffff;
      border-radius: 10px;
      position: relative;
      z-index: 2;
      margin-top: -10px;
      min-height: 222px;
      padding: 30px 40px 54px;
      .row-1 {
        font-size: 16px;
        font-weight: bold;
        color: #373842;
      }
      .row-2 {
        margin-top: 20px;
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        .left {
          flex: 0 0 auto;
          margin-right: 12px;
          .photo-img {
            display: block;
            width: 54px;
            height: 54px;
            border-radius: 50%;
          }
        }
        .right {
          overflow: hidden;
          .name {
            font-size: 15px;
            font-weight: bold;
            color: #373842;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .company {
            margin-top: 4px;
            font-size: 12px;
            font-weight: 500;
            color: #676c77;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
      .split {
        width: 100%;
        height: 1px;
        background: #f0f2f4;
      }
      .row-3 {
        margin-top: 14px;
        display: flex;
        align-items: center;
        .label {
          flex: 0 0 auto;
          font-size: 14px;
          font-weight: bold;
          color: #808795;
          margin-right: 20px;
          width: 30px;
        }
        .value {
          font-size: 14px;
          font-weight: bold;
          color: #45484e;
        }
      }
    }
  }
}
</style>
